import { render, staticRenderFns } from "./Donors.vue?vue&type=template&id=31f9fdb3&scoped=true&"
import script from "./Donors.vue?vue&type=script&lang=js&"
export * from "./Donors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f9fdb3",
  null
  
)

export default component.exports